import { Box, Typography } from '@mui/material'
import { useHasPageExternalAccess } from '~hooks/permissions/use-has-page-external-access'
import useBreakpoint from '~hooks/use-breakpoint'
import { COLORS } from '~theme/colors'
import { typography } from '~theme/global'
import { PoolSelector } from '../../pages/pages-behind-login/dashboard/v2/pool-selector/pool-selector'
import { DppPartnerHelpRibbon } from './dpp-partner-help-ribbon'
import cover from './header.jpg'
import { NotificationsBanner } from '~components/notifications/notifications-banner'

export function Splash({
  pageName,
  minimize = false,
  omitPoolSelector,
  backgroundColor,
  children,
}: {
  pageName?: string
  minimize?: boolean
  omitPoolSelector?: boolean
  backgroundColor?: string
  children?: React.ReactNode
}) {
  const isExternal = useHasPageExternalAccess()
  return (
    <>
      <SplashWrapper minimize={minimize} backgroundColor={backgroundColor}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 0,
            width: '100%',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          {pageName && (
            <Typography
              variant="h1"
              color={isExternal ? 'white' : typography.h1.color}
            >
              {pageName}
            </Typography>
          )}
          <PoolSelector
            sx={{
              ml: pageName ? 'initial' : 'auto',
              opacity: omitPoolSelector ? 0 : 1,
              pointerEvents: omitPoolSelector ? 'none' : 'auto',
            }}
            variant="secondary"
          />
          {children}
        </Box>
      </SplashWrapper>
      <DppPartnerHelpRibbon />
      <NotificationsBanner />
    </>
  )
}

function SplashWrapper({
  children,
  minimize,
  backgroundColor,
}: {
  children: React.ReactNode
  minimize?: boolean
  backgroundColor?: string
}) {
  const { isMobileSize } = useBreakpoint()
  const isExternal = useHasPageExternalAccess()

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: isMobileSize || minimize ? 'center' : 'flex-end',
        alignItems: 'flex-end',
        flexDirection: 'column',
        transition: 'height 0.2s ease-out',
        py: minimize ? 4 : 1,
        px: isMobileSize ? 2 : { xs: 4, xxxl: 14 },
        zIndex: 10,
        ...(!isExternal
          ? {
              backgroundColor: backgroundColor ?? COLORS.greys.light,
            }
          : {
              backgroundSize: 'cover',
              backgroundPosition: 'right',
              backgroundRepeat: 'no-repeat',
              backgroundImage: `url(${cover})`,
            }),
      }}
    >
      {children}
    </Box>
  )
}
